import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lp2-level-selection-page',
  template: '<lp2-level-selection-iframe></lp2-level-selection-iframe>',
  styles: [`
    :host {
      display: block;
      width: 100vw;
      height: 100vh;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LevelSelectionPageComponent {}



// WEBPACK FOOTER //
// ./ts/app/home/level-selection/level-selection-page/level-selection-page.component.ts